import type { Locales } from "@/graphql/generated";
import type { ProductType } from "@/models/ProductType";
import { entryContentApiQueryOptions } from "@/services/cms/tanstackQuery/queryOptions/entryContentApiQueryOptions";
import { webComponentQueryClient } from "./reactWrapper";

type PrefetchEntryContentParams<P extends ProductType> = {
  product: P;
  language: Locales;
  backendHost?: string;
};

export function prefetchEntryContent<P extends ProductType>({
  product,
  language,
  backendHost,
}: PrefetchEntryContentParams<P>) {
  return webComponentQueryClient.prefetchQuery(
    entryContentApiQueryOptions({
      product,
      language,
      backendHost,
    }),
  );
}
